import React from "react";

import {
    CircularProgressbar,
    buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function RingProgress({percentage}) {
    return(
        <div className="w-[30px] absolute -top-[45px] right-3">
            <CircularProgressbar
                value={percentage}
                strokeWidth={12}
                styles={buildStyles({
                    pathTransitionDuration: 0.5,
                    pathColor: `#007EB4, ${percentage / 100})`,
                    trailColor: "#D7D7D7",
                })}
            />
        </div>
    )
};
